import "./Programmes.module.css";
import Header from "@/reusable_sections/Header";
import AcademicTutoring from "./sections/AcademicTutoring";
import CoachingAndPersonalDevelopment from "./sections/CoachingAndPersonalDevelopment";
import GetStartedCta from "./sections/GetStartedCta";
import ProgrammesPricingOverview from "./sections/ProgrammesPricingOverview";
import Footer from "@/reusable_sections/Footer";
export default function ProgrammesPage() {
  return <div>
      <Header />
      <AcademicTutoring />
      <CoachingAndPersonalDevelopment />
      <ProgrammesPricingOverview />
      <GetStartedCta />
      <Footer />
    </div>;
}